import { TELEPHONE_ATTRIBUTE_TYPE_FIELD_IDs } from "@constants/self-service-constants";
import { InternationalTelephoneFormGroup } from "@containers/common/international-telephone-form-group/international-telephone-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { FormattedRpServiceConfigurationAttributeWithFields } from "@idw-types/data/rp-service-configuration";
import { useState } from "react";
import { ParsedCountry } from "react-international-phone";

type PrefilledAttributeTelephoneComponentProps = {
    attributeTypesWithField: FormattedRpServiceConfigurationAttributeWithFields;
    attributeFieldValues: { [key: string]: string };
    attributeRequired: boolean;
    onAttributeFieldChange: (changeObject: { [key: string]: { [key: string]: string } }) => void;
};

export const PrefilledAttributeTelephoneComponent = (props: PrefilledAttributeTelephoneComponentProps) => {
    const {
        attributeTypesWithField,
        attributeRequired,
        onAttributeFieldChange
    } = props;

    const [hasBeenInitialized, setHasBeenInitialized] = useState(false);

    const [phoneNumber, setPhoneNumber] = useState<{ phone: string; dialCode: string; }>({
        phone: "",
        dialCode: "1"
    });

    const handleTelephoneChange = async (phone: string, meta: { country: ParsedCountry; inputValue: string; }) => {
        const dialCode = meta.country?.dialCode || "";
        const phoneNumber = phone.split(`+${dialCode}`)[1];
        const newTelephoneAttributeFields = {
            [TELEPHONE_ATTRIBUTE_TYPE_FIELD_IDs.dialCode]: dialCode,
            [TELEPHONE_ATTRIBUTE_TYPE_FIELD_IDs.phone]: hasBeenInitialized ? phoneNumber : undefined,
        };

        onAttributeFieldChange({
            [attributeTypesWithField.attributeType.id]: newTelephoneAttributeFields
        });
        setPhoneNumber({ phone, dialCode });
        if (!hasBeenInitialized) {
            setHasBeenInitialized(true);
        }
    };

    return (
        <InternationalTelephoneFormGroup
            id={attributeTypesWithField.id}
            layout={LayoutTypes.ROW}
            labelWidth={LabelWidthTypes.MEDIUM}
            phoneNumber={phoneNumber}
            isRequired={attributeRequired}
            label={attributeTypesWithField.attributeLabel.label}
            onChange={handleTelephoneChange} />
    );
};